const SCHEDULED = 1;
const TO_BE_DETERMINED = 2;
const POSTPONED = 3;
const SUSPENDED = 4;
const CANCELLED = 5;

export default  {
    SCHEDULED,
    TO_BE_DETERMINED,
    POSTPONED,
    SUSPENDED,
    CANCELLED
};
